interface InsightsHeaderProps {
  isViewingOtherUsersThread: boolean;
  threadOwnerEmail: string | null;
  isDataDictionaryOpen: boolean;
  hasUnseenDataResults: boolean;
  onToggleDataDictionary: () => void;
}

export const InsightsHeader = ({
  isViewingOtherUsersThread,
  threadOwnerEmail,
  isDataDictionaryOpen,
  hasUnseenDataResults,
  onToggleDataDictionary,
}: InsightsHeaderProps) => {
  return (
    <div className="insights-header">
      <div className="insights-header-left">
        <h1>AI Insights Research Assistant</h1>
        {isViewingOtherUsersThread && (
          <span
            className="inline-flex items-center gap-1 ml-3 px-2.5 py-1 rounded-full bg-amber-100 text-amber-800 text-xs font-medium whitespace-nowrap"
            role="status"
          >
            Shared thread by {threadOwnerEmail ?? 'another user'}
          </span>
        )}
      </div>

      <button
        type="button"
        className={`data-dictionary-toggle ${isDataDictionaryOpen ? 'active' : ''}`}
        onClick={onToggleDataDictionary}
        aria-label={
          isDataDictionaryOpen
            ? 'Close data panel'
            : hasUnseenDataResults
              ? 'Open data panel with new query results'
              : 'Open data panel'
        }
      >
        <span className="data-dictionary-toggle-icon">☰</span>
        <span>Data Explorer</span>
        {hasUnseenDataResults && !isDataDictionaryOpen && (
          <span className="data-toggle-signal" aria-hidden="true">
            <span className="data-toggle-signal-dot" />
          </span>
        )}
      </button>
    </div>
  );
};
